export default __webpack_public_path__ + "static/media/presentation.440525a1.png";